import { getBaseAuditLogUrl } from '~/utils/apiRequest/base';

export const auditLogDomain = getBaseAuditLogUrl();

export const AUDIT_LOGS_URL = `https://${auditLogDomain}`;
